export const EXPIRY_TIME = 300;
export const GET_SIGNED_URL_API = "v1/normal-get-upload";
export const url_required_for_keys = {
  GET: "GET",
  UPLOAD: "UPLOAD",
};
